import type {
  AssetSearchVisibilityApi,
  AssetTypeApi,
  ConfidentialityLevelApi,
} from '../models/asset-api.models';

export interface LabeledOption<T extends string = string> {
  value: T;
  label: string;
}

/** Filter-only sentinel; never stored on asset versions. */
export const ASSET_TAXONOMY_FILTER_ALL = 'All';

export const ASSET_TYPE_OPTIONS: LabeledOption<AssetTypeApi>[] = [
  { value: 'Template', label: 'Template' },
  { value: 'Reference', label: 'Reference' },
  { value: 'Offering', label: 'Offering' },
  { value: 'DeliveryOutput', label: 'Delivery output' },
  { value: 'Proposal', label: 'Proposal' },
  { value: 'PointOfView', label: 'Point of view' },
  { value: 'Calculator', label: 'Calculator' },
  { value: 'Accelerator', label: 'Accelerator' },
  { value: 'ArchitectureBlueprint', label: 'Architecture blueprint' },
  { value: 'Other', label: 'Other' },
];

export const ASSET_PRACTICE_OPTIONS: LabeledOption[] = [
  { value: 'General', label: 'General' },
  { value: 'Digital Solutions', label: 'Digital Solutions' },
  { value: 'Data & AI', label: 'Data & AI' },
  { value: 'Cyber Security', label: 'Cyber Security' },
  { value: 'Managed Services', label: 'Managed Services' },
  { value: 'Dedicated Teams', label: 'Dedicated Teams' },
  { value: 'Digital Consulting', label: 'Digital Consulting' },
];

export const ASSET_PRACTICE_FILTER_OPTIONS: LabeledOption[] = [
  { value: ASSET_TAXONOMY_FILTER_ALL, label: 'All practices' },
  ...ASSET_PRACTICE_OPTIONS,
];

/** Aligns with backend `AssetSearchVisibilityLabels`. */
export const ASSET_SEARCH_VISIBILITY_OPTIONS: LabeledOption<AssetSearchVisibilityApi>[] = [
  { value: 'PublishedOnly', label: 'Published only' },
  { value: 'IncludeDrafts', label: 'Include drafts' },
  { value: 'DraftsOnly', label: 'Drafts only' },
];

export const ASSET_CONFIDENTIALITY_OPTIONS: LabeledOption<ConfidentialityLevelApi>[] = [
  { value: 'Public', label: 'Public' },
  { value: 'Internal', label: 'Internal' },
  { value: 'Confidential', label: 'Confidential' },
];
